export const eventsData = [
  {
    id: 'forum-etudiant',
    title: "Forum de l'étudiant de la formation et de l'emploi",
    date: '18-19 avril 2025',
    image:
      'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070&auto=format&fit=crop',
    description:
      'Plateforme essentielle pour connecter les jeunes talents avec les opportunités de formation.',
    content: [
      "Ce forum constitue une plateforme essentielle pour connecter les jeunes talents avec les opportunités de formation et d'emploi dans la région de Souss Massa et au-delà.",
      "Pendant deux jours, les étudiants, les jeunes diplômés et les professionnels auront accès à un large éventail de stands tenus par des établissements d'enseignement supérieur, des entreprises locales et internationales, ainsi que des centres de formation.",
      'Des conférences thématiques, des ateliers de coaching et des sessions de recrutement en direct seront également organisés pour accompagner les participants dans la construction de leur projet professionnel.',
    ],
  },
  {
    id: 'festival-timitar',
    title: 'Festival Timitar',
    date: 'Dates à venir (2025)',
    image:
      'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?q=80&w=2070&auto=format&fit=crop',
    description:
      'Le rendez-vous incontournable des musiques amazighes et du monde.',
    content: [
      'Le Festival Timitar, événement phare de la région Souss Massa, célèbre la rencontre entre les musiques amazighes et les rythmes du monde entier. Chaque année, Agadir vibre au son de la diversité culturelle et de la fraternité.',
      'Cet événement rassemble des centaines de milliers de spectateurs autour de scènes réparties dans la ville, offrant une programmation riche mêlant artistes internationaux de renom et talents locaux prometteurs.',
      "Au-delà des concerts, Timitar est un véritable vecteur de développement culturel et touristique, mettant en lumière la richesse du patrimoine immatériel de la région tout en s'ouvrant sur l'universalité de la musique.",
    ],
  },
  {
    id: 'concert-tolerance',
    title: 'Concert pour la Tolérance',
    date: 'Dates à venir (2025)',
    image:
      'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?q=80&w=2070&auto=format&fit=crop',
    description:
      'Un grand rassemblement musical célébrant le vivre-ensemble et la diversité.',
    content: [
      "Le Concert pour la Tolérance est un événement musical majeur qui se tient sur la magnifique plage d'Agadir, rassemblant des artistes de divers horizons pour célébrer les valeurs de paix, de respect et de vivre-ensemble.",
      "Diffusé à l'international, ce concert gratuit attire un public nombreux et diversifié, faisant d'Agadir une véritable capitale de la tolérance et du dialogue des cultures. Les performances live s'enchaînent dans une ambiance festive et chaleureuse.",
      "Cet événement symbolique renforce l'image du Maroc comme terre d'accueil et de coexistence, tout en offrant une vitrine exceptionnelle à la destination Agadir Souss Massa sur la scène internationale.",
    ],
  },
  {
    id: 'souss-gastro',
    title:
      "Festival International des Arts Culinaires et des Étoiles de la Cuisine 'Souss Gastro'",
    date: 'Dates à venir (2025)',
    image:
      'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2070&auto=format&fit=crop',
    description:
      'Une célébration de la gastronomie marocaine et internationale.',
    content: [
      "Le festival 'Souss Gastro' met à l'honneur la richesse du patrimoine culinaire de la région Souss Massa tout en s'ouvrant sur les gastronomies du monde. Des chefs étoilés et des talents locaux s'y rencontrent pour des démonstrations et des dégustations exceptionnelles.",
      "Au programme : masterclasses animées par des experts, concours culinaires pour les jeunes talents, ateliers interactifs et grandes expositions mettant en valeur les produits du terroir local, tels que l'huile d'argan, le safran et les produits de la mer.",
      "Ce festival est une occasion unique pour les professionnels de l'hôtellerie et de la restauration d'échanger sur les nouvelles tendances, tout en offrant au grand public une expérience gustative inoubliable.",
    ],
  },
  {
    id: 'fidadoc',
    title: 'Festival International du Film Documentaire (FIDADOC)',
    date: 'Novembre 2025',
    image:
      'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=2070&auto=format&fit=crop',
    description:
      'Le premier festival marocain exclusivement dédié au cinéma documentaire.',
    content: [
      'Le FIDADOC est un rendez-vous cinématographique incontournable qui propose une sélection rigoureuse de films documentaires issus du monde entier, avec une attention particulière portée aux productions africaines, arabes et méditerranéennes.',
      'Au-delà des projections captivantes, le festival organise des rencontres professionnelles, des ateliers de formation (la Ruche documentaire) et des débats enrichissants entre les réalisateurs et le public.',
      "En favorisant l'émergence de nouveaux talents et en soutenant la création documentaire, le FIDADOC contribue activement au développement de l'industrie cinématographique au Maroc et au rayonnement culturel d'Agadir.",
    ],
  },
  {
    id: 'moussem-taroudant',
    title: 'Moussem de Sidi Ahmed ou Moussa à Taroudant',
    date: 'Dates à venir (2025)',
    image:
      'https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=2076&auto=format&fit=crop',
    description:
      'Un événement spirituel, culturel et commercial profondément ancré dans les traditions.',
    content: [
      "Le Moussem de Sidi Ahmed ou Moussa est l'un des plus grands rassemblements religieux et culturels du sud marocain. Il attire chaque année des milliers de pèlerins et de visiteurs venus rendre hommage au saint patron de la région dans une atmosphère empreinte de spiritualité.",
      "Cet événement est également une occasion unique de découvrir les traditions locales vibrantes, avec ses impressionnants spectacles de fantasia (Tbourida), ses foires commerciales animées où s'échangent produits artisanaux et agricoles, et ses soirées de chants et danses folkloriques.",
      "Véritable carrefour de rencontres, le Moussem perpétue l'héritage culturel du Souss et joue un rôle économique majeur pour la province de Taroudant et ses environs.",
    ],
  },
]
